import bootLayout from 'static/script/app/boot/boot-layout';
import KlarnaPinUI from 'static/script/app/ui/klarna-pin-ui';
import KlarnaPinService from 'static/script/app/data/klarna-pin-service';

module.exports = initData => {
    bootLayout(initData);
    KlarnaPinService.attachTo(document);
    KlarnaPinUI.attachTo('[data-klarna-pin]');
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/klarna-pin.js